import { ImportState } from '../interfaces/ui/external-import.interface';

export const LW_EXTERNAL_IMPORT_STORAGE_KEY = 'lw_external_import';

export const INITIAL_IMPORT_STATE: ImportState = {
  isOpen: false,
  isMinimized: false,
  isLoading: false,
  isDone: false,
  hasError: false,
  errorMessage: '',
  pageEvents: [],
  currentPage: 0,
  totalPages: 0,
  totalInserted: 0,
  totalSkipped: 0,
  fromDate: '',
  toDate: '',
  progressPercentage: 0,
};

export function getDefaultDateRange(): { fromDate: string; toDate: string } {
  const toDate = new Date();
  toDate.setDate(toDate.getDate() - 1);
  const fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), 1);
  const fmt = (d: Date) => d.toISOString().split('T')[0];
  return { fromDate: fmt(fromDate), toDate: fmt(toDate) };
}
